<section
  class="bg-base-light text-left overflow-hidden {{ elementKey }}"
  [ngStyle]="wrapperStyles"
  [class.legacy-125-height]="isLegacyH125"
  [class.cursor-pointer]="props?.content?.link?.action"
  data-cy="ChartSingle:container"
  (click)="emitClick()"
>
  <div #scaleCalcElement class="flex flex-col items-start w-full relative">
    @if (labelEnabled) {
      <div
        class="header"
        [ngStyle]="headerStyles"
        [ngClass]="elementType"
        #titleDescriptionEl
        [class.legacy]="isUsingOldPaddingStrategy"
      >
        @if (title) {
          <p [ngStyle]="headerTitleStyles" class="title" data-cy="ChartSingle:title">
            @if (icon) {
              <mat-icon [svgIcon]="icon" [ngStyle]="headerIconStyles" />
            }
            <span>{{ title }}</span>
          </p>
        }
        @if (description) {
          <p class="description" [style]="descriptionStyles" data-cy="ChartSingle:description">
            <span>{{ description }}</span>
          </p>
        }
      </div>
    }
    @switch (elementType) {
      @case ('chartSingle') {
        <ng-container [ngTemplateOutlet]="valueChartTpl" />
      }
      @case ('chartPie') {
        <ng-container [ngTemplateOutlet]="noData ? noDataTpl : pieChartTpl" />
      }
      @case ('chartDoughnut') {
        <ng-container [ngTemplateOutlet]="noData ? noDataTpl : pieChartTpl" />
      }
      @case ('chartLine') {
        <ng-container [ngTemplateOutlet]="baseChartTpl" />
      }
      @case ('chartDot') {
        <ng-container [ngTemplateOutlet]="baseChartTpl" />
      }
      @case ('chartBar') {
        <ng-container [ngTemplateOutlet]="baseChartTpl" />
      }
      @case ('chartColumn') {
        <ng-container [ngTemplateOutlet]="baseChartTpl" />
      }
    }
  </div>
</section>

<ng-template #valueChartTpl>
  @let isPending = isPending$ | async;
  @if (isPending) {
    <blaze-element-loading-indicator [isVisible]="true" mode="theme" />
  } @else {
    <!-- This transformStyles$ needs to be here: BL-8200 -->
    @let transformStyles = transformStyles$ | async;
    <div
      class="relative flex flex-{{ imagePosition }} grow w-full"
      [style.align-self]="alignValueChart"
    >
      @if (!fontSizeEnabled && valueMinHeightEnabled) {
        <span>&nbsp;</span>
      }
      @if (image) {
        <img [src]="image" alt="" />
      }
      <div
        #singleValueChartEl
        class="single-value-chart-el align-{{ valueAlign }}"
        [class.flexible-font]="!fontSizeEnabled"
        [class.legacy-fixed-font]="fontSizeEnabled && !valueMinHeightEnabled"
        [ngStyle]="transformStyles"
      >
        <div class="flex flex-col items-end">
          <div class="chart-value" [ngStyle]="valueStyles" data-cy="ChartSingle:mainValue">
            @if (isMainValueVisible) {
              @if (!fieldSuffix || fieldSuffix === '%') {
                {{ mainValue | formatValue: fieldFormatter : { precision: fieldPrecision } }}
              } @else {
                {{
                  mainValue
                    | formatValue: 'currency' : { precision: fieldPrecision, currency: fieldSuffix }
                }}
              }
            } @else {
              <span class="text-primary-90">0.00</span>
            }
          </div>
          <!-- BL-2584 -->
          <!-- <div *ngIf="compareValueCompareFn && compareValue !== undefined" class="text-primary-lighter text-16 whitespace-nowrap opacity-50" [style.color]="colorChartColor" [ngClass]="scale?.scaleFontWeight" data-cy="ChartSingle:compareValue">
          <ng-container *ngIf="!fieldSuffix || fieldSuffix === '%'; else compareValueCurrencyTpl">
            {{compareValue | formatValue:'number':{precision: fieldPrecision} }}<ng-container *ngIf="fieldSuffix">{{fieldSuffix}}</ng-container>
          </ng-container>
          <ng-template #compareValueCurrencyTpl>
            {{ compareValue | formatValue:'currency':{precision: fieldPrecision, currency: fieldSuffix} }}
          </ng-template>
        </div> -->
        </div>
        <!-- BL-2584 -->
        <!-- <div *ngIf="delta && mainValue !== undefined && compareValueCompareFn" class="rounded py-2 text-14 px-4 text-base-white ml-16 flex items-center gap-4 whitespace-nowrap" [style.backgroundColor]="deltaColor" [ngClass]="scale?.scaleFontWeight" data-cy="ChartSingle:delta">
      <mat-icon *ngIf="delta === 'percent'; else deltaIsValueTpl" svgIcon="arrow_forward" [class]="deltaIconClass" />
      <ng-template #deltaIsValueTpl>{{ deltaValue > 0 ? '+' : deltaValue < 0 ? '-' : '' }}</ng-template>
      <ng-container *ngIf="!isDeltaInfinity">
        <ng-container *ngIf="!fieldSuffix || fieldSuffix === '%' || delta === 'percent'; else deltaValueCurrencyTpl">
          {{ (deltaDisplayValue || 0) | formatValue:'number':{precision: fieldPrecision} }}{{ delta === 'percent' ? '%' : '' }}<ng-container *ngIf="fieldSuffix && delta !== 'percent'">{{fieldSuffix}}</ng-container>
        </ng-container>
        <ng-template #deltaValueCurrencyTpl>
          {{ (deltaDisplayValue || 0) | formatValue:'currency':{precision: fieldPrecision, currency: fieldSuffix} }}
        </ng-template>
      </ng-container>
    </div> -->
      </div>
    </div>
  }
</ng-template>

<ng-template #pieChartTpl>
  <div class="flex h-full w-full items-center">
    <div class="flex flex-col h-full w-full">
      <blaze-chart
        [type]="elementType"
        [showDemoChart]="!chartSegmentData"
        [descriptionColor]="descriptionColor"
        [labels]="chartLabels"
        [datasets]="chartDatasets"
        [fieldPrecision]="fieldPrecision"
        [fieldSuffix]="fieldSuffix"
        [chartBorderLine]="chartBorderLine"
        [groupByMonth]="chartGroupByMonth"
        [showTotal]="showTotal"
        [maxLegendLines]="hideLegendAfterLines"
        [legendLabelFontFamily]="props?.content?.font?.fontFamily"
        [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
        (pointClicked)="chartPointClicked($event)"
      />
    </div>
  </div>
</ng-template>

<ng-template #baseChartTpl>
  <div class="flex h-full w-full items-center">
    @if (yDescription) {
      <span
        class="origin-center -rotate-90 flex justify-center w-0 h-0 mr-24 header-font"
        [class.mb-24]="xDescription"
      >
        <span class="whitespace-nowrap" [style.color]="colorGeneralAxis">{{ yDescription }}</span>
      </span>
    }
    <div class="flex flex-col h-full w-full">
      <blaze-chart
        [type]="elementType"
        [showDemoChart]="!chartGroupBy"
        [labels]="chartLabels"
        [datasets]="chartDatasets"
        [axisColor]="colorGeneralAxis"
        [descriptionColor]="descriptionColor"
        [gridLinesColor]="chartGridLines"
        [gridDensity]="chartGridDensity"
        [fieldPrecision]="fieldPrecision"
        [fieldSuffix]="fieldSuffix"
        [groupByMonth]="chartGroupByMonth"
        [legendLabelFontFamily]="props?.content?.font?.fontFamily"
        [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
        [minValue]="minValue"
        [maxValue]="maxValue"
        [curvedLines]="curvedLines"
        (pointClicked)="chartPointClicked($event)"
      />
      @if (xDescription) {
        <span class="mx-auto header-font" [style.color]="colorGeneralAxis">{{ xDescription }}</span>
      }
    </div>
  </div>
</ng-template>

<ng-template #noDataTpl>
  <div class="no-data"> No data available yet </div>
</ng-template>
